import { api, setCurrentOrg } from "./api";
import { queryClient } from "./query-client";

/**
 * Bascule vers un autre réseau (membre, ou tout réseau pour l'administrateur
 * plateforme). L'en-tête `x-organization-id` prime sur le réseau par défaut :
 * il est basculé avant de recharger toutes les données.
 */
export async function switchOrganization(orgId: string): Promise<void> {
  await api.post("/me/organization", { organizationId: orgId });
  setCurrentOrg(orgId);
  queryClient.clear();
  window.location.assign("/");
}
